import { j as t } from "./jsx-runtime-944c88e2.js";
import { D as r, a as i } from "./Dialog-a72b336a.js";
import "react";
import "react-dom";
import "./index-efd35e77.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./index-64063129.js";
import "./theme-b013fa81.js";
import "./index.es-6889c727.js";
const D = (o) => /* @__PURE__ */ t.jsx(r, { autoFocus: !0, themeColor: "light", closeIcon: !0, ...o, children: o.children }), h = i;
export {
  D as Dialog,
  h as DialogActionsBar
};
